import { DEFAULT_DIRECTORY_ICON_ID } from '@/shared/ui/module-icons';
import { getMockPermissionsForNode } from './mockDirectoryPermissions';
import type { DirectoryIconId, DirectoryTreeNode } from './types';

const defaultDetails = (
  title: string,
  iconId?: DirectoryIconId,
  createdAt: string = '2025-01-10T14:50:00.000Z'
) => ({
  title,
  iconId,
  createdAt,
  createdAtLabel: '10/01/2025 | 11:50',
  createdBy: 'Fábio Ferreira Netto',
  savedInDirectoryBy: 'Fábio Ferreira Netto',
});

const DOCUMENT_PREFIX = 'DA14.1';
const DOCUMENT_TITLE = 'Política de Tratamento de reclamação de clientes';
const DOCUMENT_NAME = `${DOCUMENT_PREFIX} - ${DOCUMENT_TITLE}`;

function createDocumentFile(id: string): DirectoryTreeNode {
  return {
    id,
    name: DOCUMENT_NAME,
    prefix: DOCUMENT_PREFIX,
    title: DOCUMENT_TITLE,
    kind: 'file',
    details: defaultDetails(DOCUMENT_NAME),
    permissions: getMockPermissionsForNode(),
  };
}

export const MOCK_AMBIENTE_MODULE_CHILDREN: DirectoryTreeNode[] = [
  {
    id: 'folder-procedimentos',
    name: 'Procedimentos',
    kind: 'folder',
    details: defaultDetails('Procedimentos'),
    permissions: getMockPermissionsForNode(),
    children: [],
  },
  {
    id: 'folder-instrucoes',
    name: 'Instruções de Trabalho',
    kind: 'folder',
    details: defaultDetails('Instruções de Trabalho'),
    permissions: getMockPermissionsForNode(),
    children: [],
  },
  {
    id: 'folder-registros',
    name: 'Registros',
    kind: 'folder',
    details: defaultDetails('Registros'),
    permissions: getMockPermissionsForNode(),
    children: [],
  },
  {
    id: 'folder-dados',
    name: 'Dados',
    kind: 'folder',
    details: defaultDetails('Dados'),
    permissions: getMockPermissionsForNode(),
    children: [
      {
        id: 'folder-pasta-01',
        name: 'Pasta 01',
        kind: 'folder',
        details: defaultDetails('Pasta 01'),
        permissions: getMockPermissionsForNode(),
        children: [],
      },
      {
        id: 'folder-pasta-02',
        name: 'Pasta 02',
        kind: 'folder',
        details: defaultDetails('Pasta 02'),
        permissions: getMockPermissionsForNode(),
        children: [
          {
            id: 'folder-subpasta',
            name: 'Subpasta',
            kind: 'folder',
            details: defaultDetails('Subpasta'),
            permissions: getMockPermissionsForNode(),
            children: [
              createDocumentFile('file-da14-1'),
              createDocumentFile('file-da14-2'),
              createDocumentFile('file-da14-3'),
              createDocumentFile('file-da14-4'),
              createDocumentFile('file-da14-5'),
            ],
          },
        ],
      },
    ],
  },
];

export const MOCK_CHILDREN_BY_MODULE_NAME: Record<string, DirectoryTreeNode[]> = {
  'Ambiente de Trabalho e Infraestrutura': MOCK_AMBIENTE_MODULE_CHILDREN,
};

export const MOCK_DIRECTORIES_TREE: DirectoryTreeNode[] = [
  {
    id: 'module-acpm',
    name: 'Ação Corretiva / Preventiva / Melhoria',
    kind: 'module',
    details: defaultDetails(
      'Ação Corretiva / Preventiva / Melhoria',
      DEFAULT_DIRECTORY_ICON_ID,
      '2024-11-01T10:00:00.000Z'
    ),
    permissions: getMockPermissionsForNode(),
    children: [],
  },
  {
    id: 'module-ambiente',
    name: 'Ambiente de Trabalho e Infraestrutura',
    kind: 'module',
    details: defaultDetails(
      'Ambiente de Trabalho e Infraestrutura',
      DEFAULT_DIRECTORY_ICON_ID,
      '2025-01-10T14:50:00.000Z'
    ),
    permissions: getMockPermissionsForNode(),
    children: structuredClone(MOCK_AMBIENTE_MODULE_CHILDREN) as DirectoryTreeNode[],
  },
];

export const DEFAULT_EXPANDED_DIRECTORY_IDS = [
  'module-ambiente',
  'folder-dados',
  'folder-pasta-02',
  'folder-subpasta',
];

export const DEFAULT_SELECTED_DIRECTORY_ID = 'module-acpm';
